import { v4 } from 'uuid'

/**
 * @param {string} [prefix] The prefix to prepend to the unique ID.
 * @param {number} [length] The length of the generated string (not including the prefix).
 *
 * @returns {string} A short, non-sequential, URL-friendly unique ID.
 *
 * @requires uuid
 */
export const createId = (prefix?: string, length = 10): string => {
  const id = v4().replace(/-/g, '')
  return `${prefix ? prefix : ''}${id.substring(0, length)}`
}
